import React, { useEffect, useState } from "react";
import "./Registration.css";
import Background from "../assets/splash-bg.jpg";
import RegistrationPhoto from "../assets/registration-page-photo.jpg";
import Footer from "./Footer.tsx";

const Registration: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  // Lock page scroll while modal is open
  useEffect(() => {
    const prev = document.body.style.overflow;
    if (isModalOpen) document.body.style.overflow = "hidden";
    else document.body.style.overflow = prev || "";
    return () => {
      document.body.style.overflow = prev || "";
    };
  }, [isModalOpen]);

  return (
    <div className="registration-container">
      {/* Header Section */}
      <div
        className="registration-hero-section"
        style={{ backgroundImage: `url(${Background})` }}
      >
        <div className="registration-overlay" />
        <div className="registration-content">
          <div className="registration-title-section">
            <h1 className="registration-page-title">REGISTRATION</h1>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="main-content">
        {/* Registration Info Section */}
        <div className="registration-info-section">
          <div className="registration-grid">
            {/* Left Column - Image */}
            <div className="registration-image-column">
              <img
                src={RegistrationPhoto}
                alt="Voices of Virtue 2025 Registration"
                className="registration-photo"
              />
            </div>

            {/* Right Column - Text and Form */}
            <div className="registration-text-column">
              <h2 className="registration-subtitle">
                REGISTRATION IS OPEN UNTIL OCTOBER 31
              </h2>
              <p className="registration-description">
                Register for Voices of Virtue 2025 using the link{" "}
                <a
                  href="https://bit.ly/vov2025"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  bit.ly/vov2025
                </a>{" "}
                or use the form down below.
              </p>

              {/* Embedded Form Area */}
              <div className="embedded-form-section">
                <div className="form-container">
                  <div className="form-wrapper">
                    <button
                      className="expand-btn"
                      onClick={openModal}
                      title="Expand form"
                      aria-label="Expand form"
                    >
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        aria-hidden="true"
                      >
                        <polyline points="15,3 21,3 21,9" />
                        <polyline points="9,21 3,21 3,15" />
                        <line x1="21" y1="3" x2="14" y2="10" />
                        <line x1="3" y1="21" x2="10" y2="14" />
                      </svg>
                    </button>
                    <iframe
                      src="https://bit.ly/vov2025"
                      title="Voices of Virtue 2025 Registration Form"
                      className="registration-iframe"
                      loading="lazy"
                      allowFullScreen
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Registration Details Section */}
        <div className="content-section">
          <h2 className="section-title">REGISTRATION DETAILS</h2>

          <ul className="registration-details-list">
            <li>
              There is a <strong>$15 fee</strong> for registration. The
              registration fee includes meals and merchandise.
              <ul>
                <li>
                  The fee does not account for housing or parking accommodations.
                  Please reference our page <strong>"Visiting BCS"</strong> for
                  details and tips on your stay at Bryan-College Station.
                </li>
              </ul>
            </li>
          </ul>

          <p className="contact-info">
            For more inquiries, please contact us at{" "}
            <strong>voicesofvirtue.cstat@gmail.com</strong>.
          </p>
        </div>
      </div>

      {/* Modal */}
      {isModalOpen && (
        <div
          className="modal-overlay"
          role="dialog"
          aria-modal="true"
          onClick={closeModal}
          onKeyDown={(e) => e.key === "Escape" && closeModal()}
        >
          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()}
            role="document"
          >
            {/* Top link removed per request */}
            <button
              className="modal-close-btn"
              onClick={closeModal}
              title="Close"
              aria-label="Close"
            >
              ✕
            </button>

            <iframe
              src="https://bit.ly/vov2025"
              title="Voices of Virtue 2025 Registration Form - Expanded"
              className="modal-iframe"
              loading="lazy"
              allowFullScreen
            />
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default Registration;
